<template>
  <div class="healthbar">
    <div class="healthbar-fill" :style="charHealthStyle"></div>
    <span class="healthbar-text">{{ character.health }}</span>
  </div>
</template>

<script>
import { shiftHealthColor, LightenDarkenColor } from "../../js/colorshift.js";

export default {
  name: "Healthbar",
  props: {
    character: {
      type: Object,
      required: true
    }
  },
  computed: {
    healthPerc() {
      return this.character.health / this.character.maxHealth;
    },

    charHealthStyle() {
      let primaryColor = shiftHealthColor(
        "rgb(179, 0, 0)",
        "rgb(0, 179, 12)",
        this.healthPerc
      );

      return {
        width: this.healthPerc * 100 + "%",
        background: primaryColor
      };
    }
  }
};
</script>